import styled from "styled-components";

const MessageParagraph = styled.div`
  font-size: 14px;
  line-height: 1.4;
  color: currentColor;

  &:last-of-type {
    margin-bottom: 0;
  }

  p {
    margin: 0;
  }

  a {
    color: white;
  }
`

export default MessageParagraph